module.exports = __webpack_public_path__ + "9788f41e/img/dollar-icon.35c9d638.svg";